export default __webpack_public_path__ + "static/Category2-d1113f7252edd3db49e77ffb07272d97.jpg";